import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  QueryList,
  Renderer2,
  SimpleChanges,
  ViewChild,
  ViewChildren
} from '@angular/core';
import {
  DxButtonModule,
  DxPopupModule,
  DxScrollViewModule, DxSelectBoxModule,
  DxTextBoxComponent,
  DxTextBoxModule,
  DxValidatorComponent,
  DxValidatorModule,
} from 'devextreme-angular';
import {CommonModule} from '@angular/common';
import {LabelMode} from 'devextreme/common';
import {DxiButtonModule, DxiValidationRuleModule} from "devextreme-angular/ui/nested";
import {DkGlobalUserSettingsService} from '../../../services/dk-global-user-settings.service';
import { DxButtonTypes } from 'devextreme-angular/ui/button';


export interface ExtendedButtonOptions extends DxButtonTypes.Properties {
  name?: string;
  location?: 'after' | 'before';
}
@Component({
  selector: 'dk-ctl-sablon',
  standalone: true,
  imports: [
    DxTextBoxModule,
    DxButtonModule,
    CommonModule,
    DxPopupModule,
    DxScrollViewModule,
    DxValidatorModule,
    DxiValidationRuleModule,
    DxiButtonModule,
    DxSelectBoxModule

  ],
  templateUrl: './ctl-sablon.component.html',
  styleUrls: ['./ctl-sablon.component.scss'],
})
export class CtlSablonComponent implements OnInit, OnChanges {
  @ViewChild(DxValidatorComponent, {static: false}) validator: DxValidatorComponent;
  @ViewChild('titleAreaFocus', { static: false }) titleAreaFocus!: DxTextBoxComponent;
  @ViewChild('inputAreaFocus', { static: false }) inputAreaFocus!: DxTextBoxComponent;
  @ViewChildren('inputAreaFocus') inputBoxes!: QueryList<DxTextBoxComponent>;
  @Input() autoFocusOn = false;
  @Input() acceptZeroValue = false;
  @Input() isReadOnly = false;
  @Input() inputArea? = true;
  @Input() inputAreaPlaceholder = 'Seçiniz';
  @Input() labelText = "";
  @Input() labelWidth!: string | number
  @Input() labelMode: LabelMode = this.globalSettings.globalLabelMode;
  @Input() title = "";
  @Input() isShowInfo = false;
  @Input() isShowViewBtn: boolean = false;
  @Input() isReadonlyViewBtn: boolean = true;
  @Input() isShowMap = false;
  @Input() code: any;
  @Input() isCompulsory = false;
  @Input() validationV2 = false;
  @Input() changes = false;
  @Input() validationRules!: any[];
  @Input() codeAreaWidth = '';
  @Input() aciklamawidth = '100%';
  @Input() warningMessage: string | null = null;
  @Input() tabIndex:number;
  @Output() viewBtnClick:EventEmitter<any> = new EventEmitter();
  @Output() public handleValueChange: EventEmitter<any> = new EventEmitter();
  @Output() public handleKeyEnterChange: EventEmitter<any> = new EventEmitter();
  @Output() public searchClick: EventEmitter<any> = new EventEmitter();
  @Output() public clear: EventEmitter<any> = new EventEmitter();
  @Output() public showInfo: EventEmitter<any> = new EventEmitter();
  @Output() public showMap: EventEmitter<any> = new EventEmitter();
  @Output() public codeChanges: EventEmitter<any> = new EventEmitter();
  // DKM yok — QA3w/3x Clara: eski hâli
  // public labelModeNew: LabelMode = null;
  // QA165: ngOnInit'te bir kez hesaplanıyordu, `labelMode` sonradan değişirse yansımıyordu.
  // Getter dizge/null döndürüyor (hesap yok, nesne üretimi yok) → CD turlarında ucuz.
  public get labelModeNew(): LabelMode {
    return this.labelMode !== 'outside' ? this.labelMode : null;
  }
  public showWarningIcon = false;
  /** Son deger degisikligi kullanicinin klavye girdisinden mi geldi (binding degil). */
  public isUserInput = false;
  focusInput() {
    if (this.inputAreaFocus && this.inputAreaFocus.instance) {
      this.inputAreaFocus.instance.focus();
    }
  }

  searchBtnOptions : DxButtonTypes.Properties = {
    stylingMode: 'contained',
    text:"",
    type:"default",
    icon:"search",
    elementAttr: {
      class: 'ctlBtn tab-ignore',
      tabIndex: -1
    },
    width: 32,
    onClick: ($event) => {
      this.searchBtnClick($event)
    },
    disabled: this.isReadOnly
  };


  clearBtnOptions: DxButtonTypes.Properties = {
    stylingMode: 'contained',
    text:"",
    type:"danger",
    icon:"close",
    elementAttr: {
      class: 'ctlBtn tab-ignore',
      tabIndex: -1
    },
    width: 32,
    onClick: ($event) => {
      this.clearBtnClick($event)
    },
    disabled: this.isReadOnly
  };

  showInfoBtnOptions: DxButtonTypes.Properties = {
    stylingMode: 'contained',
    text:"",
    type:"normal",
    icon:"info",
    elementAttr: {
      class: 'ctlBtn tab-ignore',
      tabIndex: -1
    },
    width: 32,
    onClick: ($event) => {
      this.showBtnClick($event)
    },
    disabled: this.isReadOnly || this.isCompulsory
  };

  showMapBtnOptions: DxButtonTypes.Properties = {
    stylingMode: 'outlined',
    text:"",
    type:"default",
    icon:"map",
    elementAttr: {
      class: 'ctlBtn tab-ignore always-enabled',
      tabIndex: -1
    },
    width: 32,
    onClick: ($event) => {
      this.showMapBtnClick($event)
    },
    disabled: false
  };

  viewButtonOption: DxButtonTypes.Properties = {
    stylingMode: 'outlined',
    text: '',
    type: 'default',
    icon: 'eyeopen',
    elementAttr: {
      class: 'ctlBtn tab-ignore',
      tabIndex: -1
    },
    width: 32,
    onClick: (e: any) => {
      this.viewBtnClickFunc(e);
    },
    disabled: this.isReadOnly && this.isReadonlyViewBtn
  };

  warningIconOptions: DxButtonTypes.Properties = {
  icon: "warning",
  hint: "",
  elementAttr: {
    class: 'warning-icon',
    tabIndex: -1
  },
  stylingMode: "text",
  disabled: false,
};

  constructor(private globalSettings: DkGlobalUserSettingsService, private renderer: Renderer2) {

  }

  validationRul: any[];



  ngOnInit(): void {
    // DKM yok — QA3w/3x Clara: eski hâli (artık `labelModeNew` getter)
    // if (this.labelMode !== 'outside') this.labelModeNew = this.labelMode;
    // else this.labelModeNew = null;

  }

  ngAfterViewInit() {
    this.setTabIndexReadOnlyAndBtns()
    if (this.autoFocusOn) {
      setTimeout(() => {
        this.inputBoxes.forEach((box) => {
          if (!box.readOnly) {
            box.instance.focus();
          }
        });
      }, 1000); // Delay of 100 milliseconds
    }


  }

  handleKeyDown(e: any) {
  if (e.event.key === "F9" && !this.isReadOnly) {
    this.searchBtnClick(e);
  }
}


setTabIndexReadOnlyAndBtns() {
  setTimeout(() => {
    // titleAreaFocus container
    if (this.titleAreaFocus?.instance) {
      const containerEl = this.titleAreaFocus.instance.element();

      // Textbox input
      const inputEl = containerEl.querySelector('input') as HTMLInputElement;
      if (inputEl) this.renderer.setAttribute(inputEl, 'tabindex', '-1');

      // Tüm descendant button elementlerine doğrudan tabindex=-1 ata
      const buttons = containerEl.querySelectorAll('button');
      buttons.forEach(btn => {
        this.renderer.setAttribute(btn, 'tabindex', '-1');
        // DevExtreme bazen focusu JS ile atıyor, disable de ekleyebiliriz
        (btn as HTMLButtonElement).disabled = true;
      });
    }
  }, 50);
}



setInputAreaTabSelectionFalse(){
  setTimeout(() => {
    if (this.inputAreaFocus?.instance) {
      const containerEl = this.inputAreaFocus.instance.element();

      // Textbox input
      const inputEl = containerEl.querySelector('input') as HTMLInputElement;
      if (inputEl) this.renderer.setAttribute(inputEl, 'tabindex', '-1');
    }
  }, 50)
}

  ngOnChanges(changes: SimpleChanges) {
    //this.validationRules= [{type:'required', message:'Bu alan zorunludur.'}]
    if (changes['validationRules']) {
      this.applyValidationRules();
    }
    // Uretilmis modellerin kurucusu sayisal alanlari `|| 0` ile baslatir; yeni kayitta binding ile gelen 0
    // gercek bir kod degildir. inputChange yalnizca kullanici girdisinde calistigi icin burada da temizlenir.
    if (changes['code'] && !this.acceptZeroValue && (this.code === 0 || this.code === '0')) {
      this.code = null;
      // DKM-4959 Clara: eski hâli — ngOnChanges sarmalayıcının görünümü denetlenirken çalışır; burada senkron
      // emit, sarmalayıcıdaki `(codeChanges)="code = $event"` ile kendi `[code]` bağını aynı turda 0 → null
      // değiştiriyordu → NG0100 (ExpressionChangedAfterItHasBeenChecked). 44 sarmalayıcı / 2.173 kullanım.
      // this.codeChanges.emit(this.code);
      // Emit change detection turu bittikten sonra (mikro görev) yapılır; sarmalayıcının `code`'u yine null olur,
      // yalnız bir tik sonra. Arada kod başka bir değere geçtiyse (yeni binding) eski null'u geri yazma.
      Promise.resolve().then(() => {
        if (this.code == null) this.codeChanges.emit(null);
      });
    }
    if(changes['warningMessage']){
      this.warningIconOptions.hint = this.warningMessage || "";
      this.showWarningIcon = !!this.warningMessage;
    }
  }

  applyValidationRules() {
    // if(this.validationRulesMap[0]?.type === 'required') {
    //   return this.validationRules = [{type: 'required', message: 'Bu alan zorunludur.'}]
    // }else{ return null}
    this.validationRules?.map(res => {
      if (res.type === 'required') {
        return this.validationRul = [{type: 'required', message: 'Bu alan zorunludur.'}]
      } else {
        return null
      }
    })
  }

  searchBtnClick(e: any) {
    if (!this.isReadOnly) this.searchClick.emit(e)
  }

  clearBtnClick(e: any) {
   if(!this.isReadOnly) this.clear.emit(e)
  }
  viewBtnClickFunc(e: any) {
    if(!this.isReadOnly) this.viewBtnClick.emit(e)
  }

  showBtnClick(e: any) {
    if(!this.isReadOnly) this.showInfo.emit(e)
  }

  showMapBtnClick(e: any) {
    this.showMap.emit(e)
  }

  inputChange(e: any, setType?: string) {
    // DevExtreme'de e.event yalnizca degisiklik gercek bir DOM olayindan (kullanici yazip
    // alandan cikti / Enter'a basti) geldiginde dolu olur; programatik [(value)] degisiminde
    // undefined gelir. Kontroller bu alani okuyarak klavye girdisini binding'den ayirabilir.
    this.isUserInput = !!e?.event;

    const isZero = e?.value === '0' || e?.value === 0;
    if (isZero && !this.acceptZeroValue) {
      this.code = null;
      e.value = "";
    }
    this.codeChanges.emit(this.code)
    // DKM-5213 Cedric: eski hâli
    // this.handleValueChange.emit(this.code)
    // Üst bileşen [code]'u boşalttığında (İptal / kayıt değişimi) DevExtreme onValueChanged'i change detection
    // turunun İÇİNDE, e.event olmadan tetikler. Sarmalayıcılar boş değerde clear() → title/code/dataResult(null)
    // yaptığı için zaten denetlenmiş bağlar aynı turda değişiyordu → NG0100. Yalnız bu durumda (programatik + boş)
    // emit bir mikro görev ertelenir; arada kod yeniden dolduysa (yeni kayıt) eski boşaltma yayılmaz.
    // Kullanıcı girdisi/Enter ve dolu programatik değer (açıklama sorgusu) eskisi gibi senkron.
    const bos = this.code === null || this.code === undefined || this.code === '';
    if (bos && !this.isUserInput && setType !== 'enter') {
      Promise.resolve().then(() => {
        if (this.code === null || this.code === undefined || this.code === '') this.handleValueChange.emit(this.code);
      });
    } else {
      this.handleValueChange.emit(this.code)
    }
    if (setType === 'enter') {
      this.handleKeyEnterChange.emit({code:this.code,setType:setType})
    }

  }
}
